import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, PhoneIcon, ClockIcon } from 'lucide-react';
export function Contact() {
  return <section id="contacto" className="py-14 bg-cream-100" data-id="element-56">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-57">
        <div className="text-center mb-16" data-id="element-58">
          <h2 className="text-3xl md:text-4xl font-display text-charcoal mb-4" data-id="element-59">
            Aquí estamos — cuando tú estés lista
          </h2>
          <p className="text-lg text-charcoal/70 font-light" data-id="element-60">
            Da el primer paso hoy.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-61">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-8 bg-white p-8 md:p-10 shadow-sm border border-cream-200" data-id="element-62">
            <div className="flex items-start" data-id="element-63">
              <MapPinIcon className="h-6 w-6 text-olive-500 mr-4 flex-shrink-0 mt-1" data-id="element-64" />
              <div data-id="element-65">
                <h3 className="font-medium text-charcoal mb-1" data-id="element-66">Dirección</h3>
                <p className="text-charcoal/70 font-light" data-id="element-67">
                  Cl. 27 Nte. #6AN-19
                  <br data-id="element-68" />
                  Santa Monica Residencial, Cali
                </p>
              </div>
            </div>

            <div className="flex items-start" data-id="element-69">
              <PhoneIcon className="h-6 w-6 text-olive-500 mr-4 flex-shrink-0 mt-1" data-id="element-70" />
              <div data-id="element-71">
                <h3 className="font-medium text-charcoal mb-1" data-id="element-72">
                  Teléfono / WhatsApp
                </h3>
                <p className="text-charcoal/70 font-light" data-id="element-73">316 055 1859</p>
              </div>
            </div>

            <div className="flex items-start" data-id="element-74">
              <ClockIcon className="h-6 w-6 text-olive-500 mr-4 flex-shrink-0 mt-1" data-id="element-75" />
              <div data-id="element-76">
                <h3 className="font-medium text-charcoal mb-1" data-id="element-77">Horario</h3>
                <p className="text-charcoal/70 font-light" data-id="element-78">
                  Lunes a Sábado desde las 8:00 a.m.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-center md:text-left" data-id="element-79">
            <h3 className="text-2xl font-display text-charcoal mb-6" data-id="element-80">
              Te ayudamos a encontrar el blazer o la camisa que va a cambiar
              cómo el mundo te ve — empezando esta semana.
            </h3>

            <a href="https://wa.me/573160551859?text=Quiero%20construir%20mi%20imagen" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full md:w-auto px-8 py-4 text-lg font-medium bg-olive-500 text-cream-50 hover:bg-olive-600 transition-colors duration-300 mb-4" data-id="element-81">
              Escríbenos ahora al 316 055 1859
            </a>
            <p className="text-sm text-charcoal/60 font-light italic" data-id="element-82">
              Con el mensaje: "Quiero construir mi imagen"
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}